/**
 * Domain-agnostic helpers shared by every dynamic-questionnaire normalizer
 * (compliance, hygiene, beverage inspections, …). Pure tree/id/order utilities —
 * no knowledge of any particular question shape.
 */

export function normalizeStringId(v: unknown): string | null {
  if (v === undefined || v === null || v === '') return null;
  if (typeof v === 'object' && v !== null && 'id' in v) {
    const inner = (v as { id: unknown }).id;
    if (inner === undefined || inner === null || inner === '') return null;
    return String(inner);
  }
  return String(v);
}

export function extractNumericOrder(candidates: unknown[], fallback = 0): number {
  for (const c of candidates) {
    if (c === undefined || c === null || c === '') continue;
    const n = Number(c);
    if (Number.isFinite(n)) return n;
  }
  return fallback;
}

/** Strip repeated `{ data: { ... } }` envelopes (common NestJS / gateway pattern). */
export function unwrapToDataObject(payload: unknown, maxDepth = 5): Record<string, unknown> {
  let cur: unknown = payload;
  let depth = 0;
  while (
    depth < maxDepth &&
    cur !== null &&
    cur !== undefined &&
    typeof cur === 'object' &&
    !Array.isArray(cur)
  ) {
    const o = cur as Record<string, unknown>;
    const inner = o.data;
    if (inner !== undefined && typeof inner === 'object' && inner !== null && !Array.isArray(inner)) {
      cur = inner;
      depth += 1;
      continue;
    }
    break;
  }
  if (cur === null || cur === undefined || typeof cur !== 'object' || Array.isArray(cur)) return {};
  return cur as Record<string, unknown>;
}

export function pickArray(obj: Record<string, unknown>, keys: string[]): unknown[] {
  for (const k of keys) {
    const v = obj[k];
    if (Array.isArray(v)) return v;
  }
  return [];
}
